<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { RouterView, useRoute } from '@hfc/ui-core';
import BreadcrumbGenerator from '@/page/infrastructure/components/BreadcrumbGenerator.vue';
import TheFooter from '@/shared/infrastructure/components/footer/TheFooter.ce.vue';
import TheHeading from '@/shared/infrastructure/components/heading/TheHeading.ce.vue';
import GetQuoteBannerContent from '@/page/infrastructure/components/GetQuoteBannerContent.vue';
import { usePageStore } from '@/page/infrastructure/composition/usePageStore';

const route = useRoute();
const { pageState, pageStore } = usePageStore();
const breadcrumbs = ref(route.meta.breadcrumbs);
const showGetQuoteBanner = computed(() => route.meta.hideGetQuoteBanner !== true);
const hideBannerSubMessage = ref<boolean>(route.name === 'home');

onMounted(() => {
  pageStore.setPhoneEnabledForRoute(route.path);
  pageStore.onGlobalSettingsLoaded(() => {
    pageStore.setShowShopAndCompareOutlineButton(route.path);
    pageStore.setHideQuoteButton(route.path);
  });
});
</script>

<template>
  <div v-if="pageState.globalSettings?.feedback?.globalFeedbackButton.enabled" class="floating-feedback-button-container hide-when-mobile-menu-opened">
    <feedback-modal></feedback-modal>
  </div>
  <div v-highlight class="min-h-screen bg-gray-100 flex flex-col">
    <div class="bg-gradient-to-r from-blue-900 to-blue-500">
      <div class="sticky z-50 top-0 min-h-[112px]">
        <TheHeading v-if="pageState.globalSettings" :class="{'dark': !route.meta.theme || route.meta.theme === 'dark'}" :phone-for-current-route="pageState.currentRouteSettings.phone" :show-shop-and-compare-outline-button="pageState.showShopAndCompareOutlineButton" :hide-banner-sub-message="hideBannerSubMessage" :hide-quote-button="pageState.hideQuoteButton" />
      </div>
      <div v-if="breadcrumbs && breadcrumbs.length > 1" class="hidden md:block bg-white py-2">
        <div class="flex w-full max-w-7xl mx-auto px-6">
          <BreadcrumbGenerator :breadcrumbs="breadcrumbs" />
        </div>
      </div>
      <div class="flex-grow min-h-[calc(100vh-112px)]">
        <router-view />
      </div>
      <GetQuoteBannerContent v-if="showGetQuoteBanner" :redirect-button-text="pageState.currentRouteSettings.getQuoteBannerText ?? undefined" />
      <Suspense>
        <TheFooter />
      </Suspense>
    </div>
  </div>
</template>
